import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { Combobox } from '../../Combobox/Combobox';
import { useOrganisationStore } from 'Global/Organisations/OrganisationsStore';
import OrganisationDropDown from './OrganisationDropDown';
import * as React from 'react';
import { OrganisationEntity } from 'Models/Entities';
import { useLocalStore } from 'mobx-react';
import { runInAction } from 'mobx';
import If from '../../If/If';

export interface MultiOrgHomeOrgSelectionProps {
	show: boolean;
	setShowOrganisationSelection: (show: boolean) => void;
}

function MultiOrgHomeOrgSelection({ show, setShowOrganisationSelection }: MultiOrgHomeOrgSelectionProps) {
	const intl = useIntl();

	const [showMenu, setShowMenu] = React.useState(false);
	const [organisations, setOrganisations] = React.useState<OrganisationEntity[] | null>(null);
	const orgStore = useOrganisationStore();

	React.useEffect(() => {
		setOrganisations(useOrganisationStore.getState().organisations);
	}, [orgStore.organisations]);

	const state = useLocalStore(() => ({
		organisationId: orgStore.selectedOrganisation?.id ?? null,
	}));

	React.useEffect(() => {
		runInAction(() => {
			state.organisationId = orgStore.selectedOrganisation?.id ?? null;
		});
	}, [orgStore.selectedOrganisation]);

	return (
		<>
			<div
				className={classNames(
					'home-content__container select-destination__container glass',
					show ? 'show' : '',
				)}
			>
				<p className="white">
					<FormattedMessage id="multi-org-homepage__label" defaultMessage="#BrilliantTravelsAU" />
				</p>
				<h4 className="white">
					<FormattedMessage id="multi-org-homepage__sub-label" defaultMessage="Select a destination" />
				</h4>
				<div role="button" className="custom-input-group__dropdown" tabIndex={0}>
					<div
						className="custom-input-group__dropdown__input"
						onClick={() => {
							setShowMenu(!showMenu);
						}}
						onKeyDown={() => {}}
					>
						<Combobox
							className="custom-dropdown"
							model={state}
							modelProperty="organisationId"
							label={intl.formatMessage({
								id: 'multi-org-homepage__dropdown__label',
								defaultMessage: 'Experience',
							})}
							placeholder={intl.formatMessage({
								id: 'multi-org-homepage__dropdown__placeholder',
								defaultMessage: 'Select an experience',
							})}
							options={
								organisations?.map(x => {
									return {
										display: x.name,
										value: x.id,
									};
								}) ?? []
							}
							searchable={false}
							inputProps={{
								upward: false,
								selectOnBlur: false,
							}}
							isRequired={false}
							isDisabled
						/>
					</div>
					<OrganisationDropDown
						organisations={organisations}
						show={showMenu}
						toggleShowMenu={() => {
							setShowMenu(!showMenu);
						}}
						setShowOrganisationSelection={setShowOrganisationSelection}
					/>
				</div>
			</div>
			<If condition={show}>
				<div className="fixed-bottom-left">
					<h1>
						<FormattedMessage
							id="multi-org-homepage__tagline__label"
							defaultMessage="Experience Australia with Brilliant Travels."
						/>
					</h1>
				</div>
			</If>
		</>
	);
}

export default MultiOrgHomeOrgSelection;
